import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Product } from '../../models/products.model';  // Importamos la interfaz Product
import { environment } from '../../../environments/environment';  // Importamos el entorno
import { AuthService } from '../auth/auth.service';
import { toZonedTime, format } from 'date-fns-tz';

@Injectable({
  providedIn: 'root',
})
export class OrderServiceService {
  private apiUrl = environment.apiUrl; // Usamos la URL del entorno
  private routerApi = 'api/orders'; // Usamos la URL de la API de productos
  constructor(private http: HttpClient, private authService: AuthService) { }
  // Obtener productos con filtros
  getOrders(
    page: string,
    filters?: { nombreProducto?: string; idProvaider?: string }
  ): Observable<any> {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    // Usa `page` como un parámetro de ruta y los filtros como parámetros de consulta
    let params = new HttpParams();

    if (filters) {
      if (filters.nombreProducto) {
        params = params.set('nombreProducto', filters.nombreProducto);
      }
      if (filters.idProvaider) {
        params = params.set('idProvaider', filters.idProvaider);
      }
    }
    return this.http.get<any>(`${this.apiUrl}/${this.routerApi}/${page}/web`, {
      headers,
      params,
    });
  }
  // Obtener un producto por ID
  getOrderById(id: any) {
    const token = this.authService.getUserData()?.token;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    // Usa `page` como un parámetro de ruta y los filtros como parámetros de consulta
    let params = new HttpParams();
    //return this.http.get<any>(`${this.apiUrl}/${this.routerApi}/order_details/${id}`, { headers, params });

    return new Promise((resolve, reject) => {
      this.http
        .get<any>(`${this.apiUrl}/${this.routerApi}/order_details/${id}`, {
          headers,
          params,
        })
        .subscribe({
          next: (response: any) => {
            resolve(response.data);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  /*formatDate(date: Date) {
    const dates = new Date(date);
    const day = dates.getUTCDate().toString().padStart(2, '0');
    const month = (dates.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = dates.getUTCFullYear().toString().slice(-2);
    let hours = dates.getUTCHours();
    const minutes = dates.getUTCMinutes().toString().padStart(2, '0');
    const period = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12;
    const formattedTime = `${hours}:${minutes} ${period}`;
    return `${day}/${month}/${year} - ${formattedTime}`;
  }*/
  formatDate(date: Date) {
    const colombiaTimeZone = 'America/Bogota';
    const zonedDate = toZonedTime(date, colombiaTimeZone);
    //Utilizacion de format de date-fns-tz.
    const formattedDate = format(zonedDate, 'dd/MM/yy - hh:mm a');

    return formattedDate;
  }
  // Obtener un producto por ID
  update_status(id: string, formData: FormData): Observable<any> {
    const token = this.authService.getUserData()?.token;

    // No establezcas 'Content-Type' - el navegador lo hará automáticamente con el boundary correcto
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
      // Deja que el navegador establezca el Content-Type automáticamente
    });

    return this.http.post<any>(
      `${this.apiUrl}/${this.routerApi}/update_status/${id}`,
      formData,
      { headers }
    );
  }

  // Obtener Transaction de Wompi
  getTransaction(id: any) {
    let params = new HttpParams();
    return new Promise((resolve, reject) => {
      this.http.get<any>(`${this.apiUrl}/api/paymentMethod/${id}`, { params })
        .subscribe({
          next: (response: any) => {
            resolve(response.data);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  // Obtener ventas mensuales.
  monthly_sales_summary() {
    let params = new HttpParams();
    console.log(`${this.apiUrl}/${this.routerApi}/monthly_sales_summary`)
    return new Promise((resolve, reject) => {
      this.http.get<any>(`${this.apiUrl}/${this.routerApi}/monthly_sales_summary`, { params })
        .subscribe({
          next: (response: any) => {
            resolve(response.data);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  // Obtener ordenes por estado.
  get_data_chart_orders_by_status() {
    let params = new HttpParams();
    return new Promise((resolve, reject) => {
      this.http.get<any>(`${this.apiUrl}/${this.routerApi}/get_data_chart_orders_by_status`, { params })
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  // Obtener ordenes por categoría.
  get_data_chart_orders_by_category() {
    let params = new HttpParams();
    return new Promise((resolve, reject) => {
      this.http.get<any>(`${this.apiUrl}/${this.routerApi}/get_data_chart_orders_by_category`, { params })
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }
}
